<template>
  <div class="d-flex align-items-center">
    <bs-tooltip title="Copier" placement="bottom">
      <input
        id="survey-token-field"
        class="form-control text-center hover-pointer"
        type="text"
        :value="surveyToken"
        aria-label="Copié le jeton"
        readonly
        @click="copyToClipboard()"
      />
    </bs-tooltip>

    <bs-tooltip class="p-2" :title="helperTxt" :icon="true" />
  </div>
</template>

<script>
import BsTooltip from './BsTooltip.vue'
export default {
  components: { BsTooltip },
  data() {
    return {
      helperTxt: 'Lorem ipsum dolor...',
    }
  },
  computed: {
    surveyToken() {
      return this.$page.props.survey.token
    },
  },
  methods: {
    async copyToClipboard() {
      if (!navigator.clipboard) {
        document.getElementById('survey-token-field').select()
        return document.execCommand('copy')
      }

      try {
        await navigator.clipboard.writeText(this.surveyToken)
        this.$toasted.show('Jeton copié', {
          theme: 'toasted-primary',
          duration: 3000,
        })
      } catch (error) {
        console.error('Failed to copy!', error)
      }
    },
  },
}
</script>

<style>
</style>
